import React from "react";
import { Link } from "react-router-dom";
import Cases from "./case";

const CaseStudies = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className={`case-studies-section section-padding ${props.cClass}`}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col col-lg-6 col-md-8">
            <div className="section-title-s3">
              <div className="icon">
                <i className="fi flaticon-suitcase"></i>
              </div>
              <span>Here Our Best Work</span>
              <h2>Recent Case Studies</h2>
            </div>
          </div>
        </div>

        {/* Cards without slider */}
        <div className="row" style={{ rowGap: "30px", marginBottom: "50px" }}>
          {Cases.slice(0, 6).map((cases, i) => (
            <div className="col-lg-3 col-md-4 col-sm-12" key={i}>
              <div className="grid border border-2">
                <div className="img-holder">
                  <img
                    src={cases.cImg}
                    alt=""
                    style={{ width: "100%", height: "200px" }}
                  />
                </div>
                <div
                  className="overlay text-center"
                  style={{ padding: "15px" }}
                >
                  <div className="content">
                    <h3>
                      <Link
                        className="text-dark"
                        onClick={ClickHandler}
                        to={`/case-single/${cases.slug}`}
                      >
                        {cases.cTitle}
                      </Link>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
